// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { api } from '@/api/axios-instance';
import { parseResponse } from '@/api/parse-response';
import {
  CreateExchangeOrderRequest,
  DetailedExchangeOrder,
  exchangeOrderSchema,
} from '@/exchange-order/api/types';
import { reasonToAPI } from '@/return-order/api/types';
import { serializeDateForAPI } from '@/utilities/date-time';

/**
 * Type definition for the API response wrapper.
 */
interface ApiResponse {
  data: unknown;
  metadata: { requestId: string };
}

/**
 * Creates a new exchange order with the specified details.
 * The exchange order creates linked return order and fulfillment order automatically.
 */
export async function createExchangeOrder(
  request: CreateExchangeOrderRequest
): Promise<DetailedExchangeOrder> {
  const url = '/v1/exchange-group';

  // Convert the nested returnOrder.returnType to API format (uppercase)
  const apiRequest = {
    ...request,
    returnOrder: {
      ...request.returnOrder,
      returnType: reasonToAPI(request.returnOrder.returnType),
      promiseShipDate: serializeDateForAPI(request.returnOrder.promiseShipDate),
      promiseDeliveryDate: serializeDateForAPI(
        request.returnOrder.promiseDeliveryDate
      ),
    },
    fulfillmentOrder: {
      ...request.fulfillmentOrder,
      promiseShipDate: serializeDateForAPI(
        request.fulfillmentOrder.promiseShipDate
      ),
      promiseDeliveryDate: serializeDateForAPI(
        request.fulfillmentOrder.promiseDeliveryDate
      ),
    },
  };

  const response = await api.post<ApiResponse>(url, apiRequest);

  // Parse and validate the response with Zod
  return parseResponse(exchangeOrderSchema, response.data.data, {
    schemaName: 'CreateExchangeOrder',
    endpoint: url,
  });
}
